import TableContent from './TableContent'

export {
  TableContent
}



// WEBPACK FOOTER //
// ./src/views/Content/components/index.js